<template>
  <div>
    <div class="gap">
      <div class="title title-mb">
        <div class="title-block">
          <div class="block"></div>
          <div class="titleText">基础信息</div>
        </div>
      </div>

      <el-form :model="formData" ref="form" label-suffix="：">
        <el-row :gutter="20">
          <el-col :span="12" :xs="12">
            <el-form-item label="果园名称"> {{ formData.name }} </el-form-item>
          </el-col>
          <el-col :span="12" :xs="12">
            <el-form-item label="果园区域">
              {{ formData.locDetails && formData.locDetails.split(',').slice(3).join('') }}
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="12">
            <el-form-item label="园主/场长"> {{ formData.ownerName }} </el-form-item>
          </el-col>
          <el-col :span="12" :xs="12">
            <el-form-item label="联系方式"> {{ formData.ownerContact }} </el-form-item>
          </el-col>
          <el-col :span="12" :xs="12">
            <el-form-item label="产品名称"> {{ formData.cropBrandKeyValue }} </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="gap">
      <div class="title title-mb">
        <div class="title-block">
          <div class="block"></div>
          <div class="titleText">鲜皮信息</div>
        </div>
        <div>
          <span>采摘批次：</span>
          <span>{{ freshForm.pickingBatchBizNo || '-' }}</span>
        </div>
      </div>
      <div class="hbwtween">
        <div class="file" @click="lookFile('fresh')">
          <img class="file-icon" src="https://peelprod.oss-cn-shenzhen.aliyuncs.com/biz/173026022759281382.png" />
          <div class="file-name">鲜皮照片</div>
        </div>

        <div class="flex-1">
          <TablePublic :colLists="skinColLists" :tableData="freshTableData" :paginationFlag="false" :cell-style="freshCellStyle">
            <template slot="solts" slot-scope="scope">
              <el-button
                @click="tohistory(scope.data, 'fresh')"
                type="text"
                size="small"
                class="button"
                style="font-size: 14px"
                >历史修改记录</el-button
              >
            </template>
          </TablePublic>
        </div>
      </div>
    </div>

    <div class="gap">
      <div class="title title-mb">
        <div class="title-block">
          <div class="block"></div>
          <div class="titleText">干皮信息</div>
        </div>
        <div>
          <span>干皮批次：</span>
          <span>{{ dryPeelForm.bizNo || '-' }}</span>
        </div>
      </div>
      <div class="hbwtween">
        <div class="file" @click="lookFile('dryPeel')">
          <img class="file-icon" src="https://peelprod.oss-cn-shenzhen.aliyuncs.com/biz/173026022759281382.png" />
          <div class="file-name">干皮照片</div>
        </div>

        <div class="flex-1">
          <TablePublic :colLists="halfColLists" :tableData="dryPeelTableData" :paginationFlag="false" :cell-style="dryCellStyle">
            <template slot="solts" slot-scope="scope">
              <el-button
                @click="tohistory(scope.data, 'dryPeel')"
                type="text"
                size="small"
                class="button"
                style="font-size: 14px"
                >历史修改记录</el-button
              >
            </template>
          </TablePublic>
        </div>
      </div>
    </div>

    <Mdialog
      title="历史修改记录"
      :visible.sync="historyDialog"
      width="60%"
      :close-on-click-modal="false"
      :append-to-body="true"
      :destroy-on-close="true"
      @closes="historyDialog = false"
    >
      <TablePublic :colLists="historyColLists" :tableData="historyTableData" :paginationFlag="false">
        <template slot="modificationDesc" slot-scope="scope">
          <div style="white-space: normal; text-align: left">{{ scope.data.modificationDesc }}</div>
        </template>
        <template slot="reason" slot-scope="scope">
          <div style="white-space: normal">{{ scope.data.reason }}</div>
        </template>
      </TablePublic>
    </Mdialog>

    <Mdialog
      title="查看照片视频"
      :visible.sync="fileDialog"
      width="60%"
      :close-on-click-modal="false"
      :append-to-body="true"
      :destroy-on-close="true"
      @closes="fileDialog = false"
    >
      <Photo :imgArr="imgArr" />
    </Mdialog>
  </div>
</template>

<script>
import TablePublic from '@/components/tablePublic.vue'
import Mdialog from '@/components/Mdialog'
import Photo from '@/components/photo.vue'

import { getSkinDetail } from '@/api/manage/report'

import { isDef } from '@/utils/is'
export default {
  name: 'skinDetailReport',
  components: {
    TablePublic,
    Mdialog,
    Photo,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
    },
  },
  data() {
    const _this = this
    return {
      fileDialog: false,
      weightDialog: false,
      historyDialog: false,

      importHeaders: '',
      uploadPath: '',

      skinColLists: [
        {
          prop: '',
          label: '规格',
          isTrue: true,
          formatter(row) {
            const arr = [
              row.ripenessLevelSpecAttrValueKey,
              row.locDetails?.slice(row.locDetails?.lastIndexOf(',') + 1),
              row.cultivationMethodSpecValueKey,
            ]
            return arr.filter((item) => !!item).join('-')
          },
        },
        {
          prop: 'freshFruitTotalNetWeight',
          label: '鲜果总净重（斤）',
          isTrue: true,
        },
        {
          prop: 'freshPeelTotalNetWeight',
          label: '鲜皮总净重（斤）',
          isTrue: true,
        },
        {
          prop: 'peelRate',
          label: '鲜皮率（%）',
          isTrue: true,
          formatter(row) {
            return row.peelRate ? _this.myFixed(row.peelRate, 2) : ''
          },
        },
        {
          prop: 'createBy',
          label: '鲜皮记录员',
          isTrue: true,
        },
        {
          prop: 'traceabilityNodeTime',
          label: '生产加工日期',
          isTrue: true,
          formatter(row) {
            return row.traceabilityNodeTime ? _this.parseTime(row.traceabilityNodeTime, '{y}-{m}-{d}') : ''
          },
        },
        {
          label: '操作',
          prop: '',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 200,
          rightFlag: true,
        },
      ],

      halfColLists: [
        {
          prop: '',
          label: '规格',
          isTrue: true,
          formatter(row) {
            // const arr = [
            //   row.ripenessLevelSpecAttrValueKey,
            //   row.locDetails?.slice(row.locDetails?.lastIndexOf(',') + 1),
            //   row.cultivationMethodSpecValueKey,
            //   _this.parseTime(_this.formData.freshTime, '{y}'),
            //   _this.$route.query.plantationName,
            // ]
            // return arr.filter((item) => !!item).join('-')
            return row.specDetails
          },
        },
        {
          prop: 'freshFruitTotalNetWeight',
          label: '鲜果总净重（斤）',
          isTrue: true,
        },
        {
          prop: 'totalNetWeight',
          label: '干皮总净重（斤）',
          isTrue: true,
        },
        {
          prop: 'peelRate',
          label: '出皮率（%）',
          isTrue: true,
          formatter(row) {
            return row.peelRate ? _this.myFixed(row.peelRate, 2) : ''
          },
        },
        {
          prop: 'createBy',
          label: '干皮记录员',
          isTrue: true,
        },
        {
          prop: 'traceabilityNodeTime',
          label: '干皮生产日期',
          isTrue: true,
          formatter(row) {
            return row.traceabilityNodeTime ? _this.parseTime(row.traceabilityNodeTime, '{y}-{m}-{d}') : ''
          },
        },
        {
          label: '操作',
          prop: '',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 200,
          rightFlag: true,
        },
      ],

      historyColLists: [
        {
          prop: 'modificationDesc',
          label: '修改内容',
          isTrue: true,
          formSolt: true,
        },
        {
          prop: 'reason',
          label: '修改原因',
          isTrue: true,
          formSolt: true,
        },
        {
          prop: 'createTime',
          label: '修改日期',
          isTrue: true,
          formatter(row) {
            return row.createTime ? _this.parseTime(row.createTime, '{y}-{m}-{d}') : ''
          },
          width: '150',
        },
        {
          prop: 'createBy',
          label: '修改人',
          isTrue: true,
          width: '150',
        },
      ],

      formData: { attachments: [] },
      tableData: [],

      historyTableData: [],

      imgArr: [],
      videoArr: [],

      freshForm: {},
      dryPeelForm: {},
      freshTableData: [],
      dryPeelTableData: [],

      rateMap: {},
    }
  },
  watch: {
    data: {
      handler(form) {
        if (!form) return

        const { freshPeelMaxFairValue, freshPeelMinFairValue, dryPeelMaxFairValue, dryPeelMinFairValue } = form
        this.rateMap = {
          freshPeelMaxFairValue,
          freshPeelMinFairValue,
          dryPeelMaxFairValue,
          dryPeelMinFairValue,
        }
        this.getDetail(form)
      },
      immediate: true,
    },
  },
  mounted() {
    console.log(3333333333)
  },
  methods: {
    freshCellStyle({ row, column, rowIndex, columnIndex }) {
      const { freshPeelMaxFairValue, freshPeelMinFairValue, } = this.rateMap
      if (
        isDef(freshPeelMaxFairValue) &&
        isDef(freshPeelMinFairValue) &&
        (row.peelRate > freshPeelMaxFairValue || row.peelRate < freshPeelMinFairValue) &&
        [4].includes(columnIndex)
      ) {
        return {
          background: '#feeaea',
          color: 'red',
        }
      } 
    },
    dryCellStyle({ row, column, rowIndex, columnIndex }) {
      const { dryPeelMaxFairValue, dryPeelMinFairValue } = this.rateMap
      if (
        isDef(dryPeelMaxFairValue) &&
        isDef(dryPeelMinFairValue) &&
        (row.peelRate > dryPeelMaxFairValue || row.peelRate < dryPeelMinFairValue) &&
        [4].includes(columnIndex)
      ) {
        return {
          background: '#feeaea',
          color: 'red',
        }
      }
    },
    async getDetail({ dryPeelProdRecId, freshPeelProdRecId, plantationId }) {
      const data = await getSkinDetail({ dryPeelProdRecId, freshPeelProdRecId, plantationId })
      if (!data.flag || data.code !== 200) return

      this.formData = data.data.plant || {}
      this.freshForm = data.data.fresh || {}
      this.dryPeelForm = data.data.dryPeel || {}
      
      this.freshTableData = Object.keys(this.freshForm).length ? [this.freshForm] : []
      this.dryPeelTableData = Object.keys(this.dryPeelForm).length ? [this.dryPeelForm] : []
    },
    lookFile(type) {
      if (type == 'fresh') {
        this.imgArr = this.freshForm.attachList?.filter((item) => item.type == 2).map((item) => item.url) || []
      } else if (type == 'dryPeel') {
        this.imgArr = this.dryPeelForm.attachList?.filter((item) => item.type == 2).map((item) => item.url) || []
      }
      this.fileDialog = true
    },
    back() {
      this.$router.push('/taskPick')
    },
    historySummaryMethod(param) {
      const { columns, data } = param
      const sums = []

      // this.settleAmountPayAmount = 0
      columns.forEach((column, index) => {
        if (index == 1) {
          sums[index] = '合计'
          return
        }

        if (index == 3) {
          sums[index] = data.reduce((prev, cur) => {
            return prev + (cur.num || 0)
          }, 0)
          return
        }
      })
      return sums //返回sums数组,sums数组中各项就会显示在合计行的各列中
    },
    weightSummaryMethod(param) {
      const { columns, data } = param
      const sums = []

      // this.settleAmountPayAmount = 0
      columns.forEach((column, index) => {
        if (index == 1) {
          sums[index] = '合计'
          return
        }

        if (index == 3) {
          sums[index] = data.reduce((prev, cur) => {
            return prev + (cur.num || 0)
          }, 0)
          return
        }
        if (index == 4) {
          sums[index] = data.reduce((prev, cur) => {
            return prev + (cur.num || 0)
          }, 0)
          return
        }
        if (index == 5) {
          sums[index] = data.reduce((prev, cur) => {
            return prev + (cur.num || 0)
          }, 0)
          return
        }
        if (index == 6) {
          sums[index] = data.reduce((prev, cur) => {
            return prev + (cur.num || 0)
          }, 0)
          return
        }
      })
      return sums //返回sums数组,sums数组中各项就会显示在合计行的各列中
    },
    toWeightRecord() {},
    tohistory(data) {
      this.historyTableData = data.resumeList
      this.historyDialog = true
    },

    beforeAvatarUpload() {},
    handleAvatarError() {},
    handlePropress() {},
    handleAvatarSuccess() {},
    handleDel() {},
    handleDelFile() {},
  },
}
</script>

<style scoped lang="less">
@import '~@/assets/variables.less';
@import '../../../../assets/form.less';

.el-icon-arrow-left {
  font-size: 30px;
  margin-top: 5px;
  color: @theme-color;
  cursor: pointer;
}
::v-deep {
  .no-contract-type {
    padding: 30px;
    background-color: #f8f8f8;
    border-radius: 12px;
    text-align: center;
    border: 1px solid #dde4ff;
    margin-bottom: 20px;
  }
}
.gap {
  margin-bottom: 30px;
}
.hbwtween {
  display: flex;
  justify-content: space-between;
}

.flex-1 {
  flex: 1;
}

.file {
  display: inline-block;
  cursor: pointer;
  &-icon {
    width: 100px;
    height: 100px;
  }
  &-name {
    font-size: 16px;
    text-align: center;
  }
}

::v-deep {
  .m-steps {
  }
  .el-form-item {
    margin-bottom: 0;
  }
  .el-form-item__label {
    color: #000;
  }
}
</style>
